import React, { useState, useEffect } from "react";
import Header from "../nav/Header";
import {
  Card,
  CardHeader,
  CardTitle,
  CardImage,
  CardSubtitle,
  CardBody,
} from "@progress/kendo-react-layout";

function Videos() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const dataFromServer = await fetchData();
      setData(dataFromServer);
    };
    getData();
  }, []);

  //Fetch Guides from API
  const fetchData = async () => {
    const res = await fetch("https://saraiapp.com/api/videos");
    const data = await res.json();
    //console.warn(data)
    return data;
  };
  //replace html tags in the data sent from DB
  //const replaceTags = /(<([^>]+)>)/ig

  return (
    <React.Fragment>
      <Header />

      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Learn On The Go</h1>
            <h2 className="sub-header mt-0">
              Our videos are created by a team of experts. The goal is to help
              you learn all about pregnancy and childbirth on the go. Gain
              insignts into common pregnancy risks, postpartum depression, how
              to care for your baby and much more.
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h1 className="get-started">Meet The Instructors</h1>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-3">
            <Card>
              <CardImage src="https://images.pexels.com/photos/5452256/pexels-photo-5452256.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>Jane Doe</CardTitle>
                  <CardSubtitle>
                    <div>Medical Dr</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://images.pexels.com/photos/1181742/pexels-photo-1181742.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>Jane Doe</CardTitle>
                  <CardSubtitle>
                    <div>Midwife</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://images.pexels.com/photos/5327656/pexels-photo-5327656.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>John Doe</CardTitle>
                  <CardSubtitle>
                    <div>Medical Dr</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://images.pexels.com/photos/5452201/pexels-photo-5452201.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" />
              <div>
                <CardHeader>
                  <CardTitle>Jane Doe</CardTitle>
                  <CardSubtitle>
                    <div>Medical Dr</div>
                  </CardSubtitle>
                </CardHeader>
              </div>
            </Card>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-12">
            <h1 className="welcome">Recent Videos</h1>
          </div>
        </div>
        <div className="row">
          {data.map((item) => (
            <div className="col-6 mb-5" key={item.id}>
              <Card>
                <iframe
                  width="453"
                  height="380"
                  src={item.iframeSource}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title={item.title}
                />
                <div>
                  <CardHeader>
                    <CardTitle>{item.title}</CardTitle>
                    <CardSubtitle>
                      <div>Instructor: DR Jane Doe</div>
                      <div>Price: {item.type}</div>
                      <div>Category: {item.category} </div>
                    </CardSubtitle>
                  </CardHeader>
                  <CardBody>
                    <p>{item.description}</p>
                  </CardBody>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
      {/* Container*/}
    </React.Fragment>
  );
}

export default Videos;
